// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboardFooter.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  const { isNil } = require('lodash/fp');
  var PermissionDashboardFooter = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.dashboards = this.props.permission.dashboards;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var tenantDetail = this.props.permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var isTemplatePermissions = this.props.isTemplatePermissions;
      var hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
      var hasExportLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);

      return (
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.actions)) && (
          <GridLayout className='izenda-GridLayout-Custom'>
            <GridLayout.Row className='u_paddingTop u_paddingBottom'>
              <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                {localization.getText('COMMON_LABEL_ACTIONS')}
              </GridLayout.Col>
              {hasScheduleLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.schedule) && (
                <GridLayout.Col cols={2}>
                  <div className='u_inlineBlock izenda-PermissionCategory-group'>
                    <label>
                      <Input
                        type='checkbox'
                        readOnly={this.props.readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dashboards.actions.schedule)}
                        onChange={notifyChange(
                          permission.updateData.bind(permission, this.dashboards.actions, 'schedule'),
                          EventsUtils.CHECKBOX
                        )}
                      />
                      <span>{localization.getText('COMMON_LABEL_SCHEDULE')}</span>
                    </label>
                  </div>
                </GridLayout.Col>
              )}
              {hasScheduleLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.subscribe) && (
                <GridLayout.Col cols={2}>
                  <div className='u_inlineBlock izenda-PermissionCategory-group'>
                    <label>
                      <Input
                        type='checkbox'
                        readOnly={this.props.readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dashboards.actions.subscribe)}
                        onChange={notifyChange(
                          permission.updateData.bind(permission, this.dashboards.actions, 'subscribe'),
                          EventsUtils.CHECKBOX
                        )}
                      />
                      <span>{localization.getText('COMMON_LABEL_SUBSCRIBE')}</span>
                    </label>
                  </div>
                </GridLayout.Col>
              )}
              {(isNil(tenantDetail) || tenantDetail.dashboards.actions.configureAccessRights) && (
                <GridLayout.Col cols={5}>
                  <div className='u_inlineBlock izenda-PermissionCategory-group'>
                    <label>
                      <Input
                        type='checkbox'
                        readOnly={this.props.readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.dashboards.actions.configureAccessRights)}
                        onChange={notifyChange(
                          permission.updateData.bind(permission, this.dashboards.actions, 'configureAccessRights'),
                          EventsUtils.CHECKBOX
                        )}
                      />
                      <span>{localization.getText('PERMISSION_LABEL_CONFIGURE_ACCESS_RIGHT')}</span>
                    </label>
                  </div>
                </GridLayout.Col>
              )}
              {permission.isTenantSetup && (
                <GridLayout.Col cols={1} className='u_textCenter pull-right'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(this.dashboards.actions.tenantAccess)}
                    onChange={notifyChange(
                      permission.updateTenantAccess.bind(permission, this.dashboards, this.dashboards.actions),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
            {(isNil(tenantDetail) ||
              tenantDetail.dashboards.actions.email ||
              tenantDetail.dashboards.actions.print) && (
              <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory' />
                {(isNil(tenantDetail) || tenantDetail.dashboards.actions.email) && (
                  <GridLayout.Col cols={2}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group'>
                      <label>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dashboards.actions.email)}
                          onChange={notifyChange(
                            permission.updateData.bind(permission, this.dashboards.actions, 'email'),
                            EventsUtils.CHECKBOX
                          )}
                        />
                        <span>{localization.getText('COMMON_LABEL_EMAIL')}</span>
                      </label>
                    </div>
                  </GridLayout.Col>
                )}
                {hasExportLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.print) && (
                  <GridLayout.Col cols={2}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group'>
                      <label>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dashboards.actions.print)}
                          onChange={notifyChange(
                            permission.updateData.bind(permission, this.dashboards.actions, 'print'),
                            EventsUtils.CHECKBOX
                          )}
                        />
                        <span>{localization.getText('COMMON_LABEL_PRINT')}</span>
                      </label>
                    </div>
                  </GridLayout.Col>
                )}
                {hasExportLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.exporting) && (
                  <GridLayout.Col cols={5}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group'>
                      <label>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dashboards.actions.exporting)}
                          onChange={notifyChange(
                            permission.updateData.bind(permission, this.dashboards.actions, 'exporting'),
                            EventsUtils.CHECKBOX
                          )}
                        />
                        <span>{localization.getText('COMMON_LABEL_EXPORT')}</span>
                      </label>
                    </div>
                  </GridLayout.Col>
                )}
                <GridLayout.Col cols={1} />
              </GridLayout.Row>
            )}
            {(isNil(tenantDetail) ||
              tenantDetail.dashboards.actions.del ||
              tenantDetail.dashboards.actions.overwriteExistingDashboard) && (
              <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory' />
                {(isNil(tenantDetail) || tenantDetail.dashboards.actions.del) && (
                  <GridLayout.Col cols={2}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group'>
                      <label>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dashboards.actions.del)}
                          onChange={notifyChange(
                            permission.updateData.bind(permission, this.dashboards.actions, 'del'),
                            EventsUtils.CHECKBOX
                          )}
                        />
                        <span>{localization.getText('COMMON_LABEL_DELETE')}</span>
                      </label>
                    </div>
                  </GridLayout.Col>
                )}
                {(isNil(tenantDetail) || tenantDetail.dashboards.actions.overwriteExistingDashboard) && (
                  <GridLayout.Col cols={7}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group'>
                      <label>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.dashboards.actions.overwriteExistingDashboard)}
                          onChange={notifyChange(
                            permission.updateData.bind(
                              permission,
                              this.dashboards.actions,
                              'overwriteExistingDashboard'
                            ),
                            EventsUtils.CHECKBOX
                          )}
                        />
                        <span>{localization.getText('PERMISSION_LABEL_OVERWRITE_EXISTING_DASHBOARD')}</span>
                      </label>
                    </div>
                  </GridLayout.Col>
                )}
                <GridLayout.Col cols={1} />
              </GridLayout.Row>
            )}
          </GridLayout>
        )
      );
    }
  });

  module.exports = connect()(PermissionDashboardFooter);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionDashboardFooter.jsx